<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SEARCH_COND')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectSearchCondition"
              v-model="queryData.searchCondition"
              codeId="COD_MAIL_STRBX_SEARCH_COND"
              :defaultOption="'all'"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.searchText"
              maxlength="100"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_KEYWORD')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="queryData.mailStorageBoxKeywordValue"
              maxlength="100"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridMailStorageBox"
        :columns="columnMailStorageBox"
        :dataset="'dsMailStorageBox'"
        :showDisplayCountControl="true"
        :initial-pagesize="5"
        @rowselect="onRowSelect"
      />
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :pageId="contextPageId"
          :selectedPageId="selectedPageId"
          :selectedGridRowData="selectedGridRowData"
          @clearGridSelection="clearGridSelection"
          @research="onClickSearch"
          @openMenuPopup="setMenuPageId"
        />
      </sui-page-tab-box-type>
      <sui-popup
        v-model="isShownMenuPopup"
        :title="$t('MSG_TIT_MENU_RGST')"
      >
        <p01
          :parentPageId="contextPageId"
          :menuPageId="menuPageId"
          @closePopup="menuPopupOpenOrClose"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMM_00008_T01.vue';
import tab02 from '../U/components/PGE_CMU_00001_T07.vue';
import p01 from './components/PGE_CMM_00008_P01';

export default {
  name: 'PGE_CMM_00008', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    p01,
  },
  extends: BasePage,
  data() {
    return {
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_MAIL_STRBX'),
          component: tab01,
        },
        {
          tabTitle: this.$t('MSG_TXT_ROLE'),
          component: tab02,
        },
      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        searchCondition: '',
        searchText: '',
        mailStorageBoxKeywordValue: '',
      },
      selectedPageId: '',
      menuPageId: '',
      isShownMenuPopup: false,
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsMailStorageBox',
    type: 'local',
    datafields: [
      {
        name: 'mailStorageBoxName',
        type: 'string',
        map: 'mailStorageBoxName',
      },
      {
        name: 'mailStorageBoxId',
        type: 'string',
        map: 'mailStorageBoxId',
      },
      {
        name: 'mailStorageBoxKeywordValue',
        type: 'string',
        map: 'mailStorageBoxKeywordValue',
      },
      {
        name: 'mailMovementYn',
        type: 'string',
        map: 'mailMovementYn',
      },
      {
        name: 'prthInclusionYn',
        type: 'string',
        map: 'prthInclusionYn',
      },
      {
        name: 'pageId',
        type: 'string',
        map: 'pageId',
      },
      {
        name: 'finalModificationDTM',
        type: 'string',
        map: 'finalModificationDTM',
      },
      {
        name: 'finalModificationLoginId',
        type: 'string',
        map: 'finalModificationLoginId',
      },
      {
        name: 'finalModificationKnoxId',
        type: 'string',
        map: 'finalModificationKnoxId',
      },
      {
        name: 'finalModificationUserId',
        type: 'string',
        map: 'finalModificationUserId',
      },
      {
        name: 'finalModificationUserName',
        type: 'string',
        map: 'finalModificationUserName',
      },
      {
        name: 'finalModificationUserGlobalName',
        type: 'string',
        map: 'finalModificationUserGlobalName',
      },
      {
        name: 'finalModificationDepartmentName',
        type: 'string',
        map: 'finalModificationDepartmentName',
      },
      {
        name: 'finalModificationDepartmentEnglishName',
        type: 'string',
        map: 'finalModificationDepartmentEnglishName',
      },
      {
        name: 'finalModificationDisplayLangId',
        type: 'string',
        map: 'finalModificationDisplayLangId',
      },
    ],
  }],
  created() {
    this.columnMailStorageBox = [
      {
        text: this.$t('MSG_TXT_SN'),
        datafield: '',
        cellsrenderer: (row, column, value) => `<div style="margin: 8.2px;">${row + 1}</div>`,
        width: 80,
      },
      {
        text: this.$t('MSG_TXT_MAIL_STRBX_NM'),
        datafield: 'mailStorageBoxName',
      },
      {
        text: this.$t('MSG_TXT_MAIL_STRBX_ID'),
        datafield: 'mailStorageBoxId',
      },
      {
        text: this.$t('MSG_TXT_KEYWORD'),
        datafield: 'mailStorageBoxKeywordValue',
      },
      {
        text: this.$t('MSG_TXT_FNL_MDFC_USR_ID'),
        datafield: 'finalModificationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              knoxId: 'finalModificationKnoxId',
              loginId: 'finalModificationLoginId',
              userId: 'finalModificationUserId',
              userName: 'finalModificationUserName',
              userGlobalName: 'finalModificationUserGlobalName',
              departmentName: 'finalModificationDepartmentName',
              departmentEnglishName: 'finalModificationDepartmentEnglishName',
              displayLanguageId: 'finalModificationDisplayLangId',
            },
          }, this.dsMailStorageBox, this.$refs.gridMailStorageBox);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 200,
      },
      {
        text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellDateLabel(row, column, value, htmlElement, {
          }, this.dsMailStorageBox, this.$refs.gridMailStorageBox);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: 150,
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    onClickSearch() {
      const dataParams = {
        searchCondition: this.queryData.searchCondition,
        searchText: this.queryData.searchText,
        mailStorageBoxKeywordValue: this.queryData.mailStorageBoxKeywordValue,
      };
      http.request(this.contextPageId, 'DTS_CMM_00009', {
        query: dataParams,
      }).then(res => {
        this.dsMailStorageBox.setRawData(res.data);
      });
    },
    onClickReset() {
      this.$refs.codeSelectSearchCondition.reset();
      this.queryData.searchText = '';
      this.queryData.mailStorageBoxKeywordValue = '';
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onRowSelect(event) {
      if (event.args.rowindex >= 0) {
        this.selectedGridRowData = event.args.row;
        this.selectedPageId = this.selectedGridRowData.pageId;
      }
    },
    clearGridSelection() {
      this.dsMailStorageBox.clearSelection();
      this.selectedGridRowData = {};
    },
    menuPopupOpenOrClose() {
      this.isShownMenuPopup = !this.isShownMenuPopup;
    },
    setMenuPageId(data) {
      this.menuPageId = data;
      this.menuPopupOpenOrClose();
    },
  },
};
</script>

<style scoped>
</style>
